import { downloadEncodedUri } from "./downloadEncodedUri";

export const downloadCsv = (options: { filename: string; csv: string }) => {
  downloadEncodedUri({
    filename: options.filename,
    encodedUri: encodeURI(`data:text/csv;charset=utf-8,${options.csv}`),
  });
};
